import { searchFilterKeysMap } from '@rover/shared/js/search/utilities/searchFiltersMap';
import { PetType as PetTypeEnum } from '@rover/types/src/Pet';

/**
 * @description sets the pet type query param from an array. ie; [cat, dog]
 * @param searchParams
 * @param petTypes
 */
export const setPetType = (searchParams: URLSearchParams, petTypes?: string[]): void => {
  if (!petTypes) {
    return;
  }

  for (const petType of petTypes) {
    if (
      Object.values(PetTypeEnum).includes(petType as PetTypeEnum) &&
      !searchParams.getAll('pet_type').includes(petType)
    ) {
      searchParams.append(searchFilterKeysMap.petType, petType);
    }
  }
};
